export default __webpack_public_path__ + "static/media/419.f68f1b67.png";